import http, { api, clear } from '@/utils/http'
import Api from '@/conf/Api';
import notify from '@/utils/notify'

const DEFAULT = (fn, commit) => fn().then(e => (notify(commit, e), e)).catch(e => (notify(commit, e), e))
export const VTEXP_NOVO = ({ commit }, data) => api(Api.admin.vtal.novo, data, commit)
export const VTEXP_EDITAR = ({ commit }, data) => api(Api.admin.vtal.editar, data, commit)
export const VTEXP_LISTA = ({ commit }, data) => api(Api.admin.vtal.lista, data, commit)
export const VTEXP_DESATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.vtal.desativa + ID), commit)
export const VTEXP_ATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.vtal.ativa + ID), commit)
export const VTEXP_EXCLUIR = ({ commit }, ID) => DEFAULT(() => http.delete(Api.admin.vtal.excluir + ID), commit)
export const VTEXP_VINCULA = ({ commit }, data) => api(Api.admin.vtal.vincula, data, commit)
export const VTEXP_VINCULA_EXCECAO = ({ commit }, data) => api(Api.admin.vtal.vinculaExcecao, data, commit)
export const VTEXP_DESVINCULA = ({ commit }, data) => api(Api.admin.vtal.desvincula, data, commit)
export const VTEXP_EXCECOES = ({ commit }, ID) => DEFAULT(() => http.get(Api.admin.vtal.excecoes.replace("?", ID)), commit)

// Praças V.tal (sc-9878). Como DEFAULT, mas em erro devolve e.response (igual ao api()),
// para a view ler r.status nas rotas sem corpo.
const RESPOSTA = (fn, commit) => fn().then(r => (notify(commit, r), r)).catch(e => (notify(commit, e), e.response || e))
const somenteDigitos = (v) => String(v || '').replace(/\D/g, '')
export const PRACA_PENDENCIAS = ({ commit }) => RESPOSTA(() => http.get(Api.admin.praca.pendencias), commit)
export const PRACA_TIPOS = ({ commit }) => RESPOSTA(() => http.get(Api.admin.praca.tipos), commit)
export const PRACA_SUGESTOES = ({ commit }, idCidade) => RESPOSTA(() => http.get(Api.admin.praca.sugestoes.replace('?', idCidade)), commit)
export const PRACA_BUSCA_CEP = ({ commit }, { idCidade, logradouro }) =>
    RESPOSTA(() => http.get(Api.admin.praca.busca.replace('?', idCidade) + '?logradouro=' + encodeURIComponent(logradouro)), commit)
export const PRACA_CONFERE_CEP = ({ commit }, { idCidade, cep }) =>
    RESPOSTA(() => http.get(Api.admin.praca.confere.replace('?', idCidade).replace('?', somenteDigitos(cep))), commit)
export const PRACA_LISTA = ({ commit }, data = {}) => api(Api.admin.praca.lista, data, commit)
export const PRACA_NOVA = ({ commit }, data) => api(Api.admin.praca.nova, data, commit)
export const PRACA_EDITAR = ({ commit }, data) => api(Api.admin.praca.editar, data, commit)
export const PRACA_EXCLUIR = ({ commit }, ID) => RESPOSTA(() => http.delete(Api.admin.praca.excluir + ID), commit)
export const PRACA_GET = ({ commit }, ID) => RESPOSTA(() => http.get(Api.admin.praca.get + ID), commit)

// Cliente do cliente (sc-9885). A lista vazia volta 404, que o notify ignora: a view trata como [].
// Novo e editar levam id_cliente, que o backend exige; editar leva etag (412). Ativar e desativar
// vão à mesma rota de status, com o corpo explícito (sc-9886 do backend; sem corpo também ativa).
export const CLIENTE_CLIENTE_LISTA = ({ commit }, data = {}) => api(Api.admin.clienteCliente.lista, data, commit)
export const CLIENTE_CLIENTE_NOVO = ({ commit }, data) => api(Api.admin.clienteCliente.novo, data, commit)
export const CLIENTE_CLIENTE_EDITAR = ({ commit }, { id, ...dados }) => RESPOSTA(() => http.put(Api.admin.clienteCliente.editar + id, dados), commit)
export const CLIENTE_CLIENTE_ATIVAR = ({ commit }, ID) => RESPOSTA(() => http.put(Api.admin.clienteCliente.status.replace('?', ID), { status: 'ativo' }), commit)
export const CLIENTE_CLIENTE_DESATIVAR = ({ commit }, ID) => RESPOSTA(() => http.put(Api.admin.clienteCliente.status.replace('?', ID), { status: 'inativo' }), commit)
export const CLIENTE_CLIENTE_EXCLUIR = ({ commit }, ID) => RESPOSTA(() => http.delete(Api.admin.clienteCliente.excluir + ID), commit)
export const CLIENTE_CLIENTE_GET = ({ commit }, ID) => RESPOSTA(() => http.get(Api.admin.clienteCliente.get + ID), commit)

// Pendências de técnico V.texp (sc-9881). A sugestão aceita a matrícula como foi digitada: o
// backend ignora caixa e espaços nas pontas, mas a URL precisa dela limpa e codificada.
export const VTEXP_PENDENCIAS = ({ commit }) => RESPOSTA(() => http.get(Api.admin.vtexpPendencia.pendencias), commit)
export const VTEXP_SUGESTAO = ({ commit }, matricula) =>
  RESPOSTA(() => http.get(Api.admin.vtexpPendencia.sugestao.replace('?', encodeURIComponent(String(matricula || '').trim()))), commit)
export const VTEXP_CADASTRA_VINCULA = ({ commit }, data) => api(Api.admin.vtexpPendencia.cadastraVincula, data, commit)

export const MATERIAL_SERVICETYPE = ({ commit }, d) => {
    let url = ''
    if (d.t == 'del') url += d.id
    if (d.t == 'get') url += d.id + '/lista'
    return DEFAULT(() => http[d.t](Api.admin.material.serviceType + url, d.p), commit)
}
export const MATERIAL_NOVO = ({ commit }, data) => api(Api.admin.material.novo, data, commit)
export const MATERIAL_GET = ({ commit }, data) => api(Api.admin.material.get, data, commit)
export const MATERIAL_SKU = ({ commit }, data) => api(Api.admin.material.sku, data, commit)
export const MATERIAL_LIST = ({ commit }, data) => api(Api.admin.material.list, data, commit)
export const MATERIAL_UPDATE = ({ commit }, data) => api(Api.admin.material.update, data, commit)
/* export const MATERIAL_DEL = ({ commit }, data) => api(Api.admin.material.del, data, commit) */
export const MATERIAL_ATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.material.ativa + ID), commit)
export const MATERIAL_DESATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.material.desativa + ID), commit)

export const NUH_GET = ({ commit }) => DEFAULT(() => http.get(Api.admin.nuh.get), commit)
export const NUH_POST = ({ commit }, data) => DEFAULT(() => http.post(Api.admin.nuh.post, data), commit)

export const CONTRATO_CRIAR = ({ commit }, data) => DEFAULT(() => http.post(Api.admin.contratos.url, data), commit)
export const CONTRATO_ALTERA = ({ commit }, data) => DEFAULT(() => http.put(Api.admin.contratos.url + "/" + data.id, data), commit)
export const CONTRATO_LISTA = ({ commit }) => DEFAULT(() => http.post(Api.admin.contratos.list), commit)
export const CONTRATO_LISTA_DOUTOR = ({ commit }, ID) => DEFAULT(() => http.post(Api.admin.contratos.dlist + ID), commit)
export const CONTRATO_PENDENCIA = ({ commit }, data) => DEFAULT(() => http.post(Api.admin.contratos.pendencia.replace("?", data.id), { id_doutor: data.id_doutor }), commit)
export const CONTRATO_PENDENCIA_DEL = ({ commit }, data) => DEFAULT(() => http.delete(Api.admin.contratos.pendenciadel.replace("?", data.id) + data.id_doutor), commit)
export const CONTRATO_ATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.contratos.ativa.replace("?", ID)), commit)
export const CONTRATO_DESATIVA = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.contratos.desativa.replace("?", ID)), commit)

export const FINALIZACAO = ({ commit }, { ID, data }) => DEFAULT(() => http.put(Api.admin.jobs.finalizacao.replace("?", ID), data), commit)

export function MENU() {
    return http.get(Api.admin.menu.menu)
}

export const FINALIZA_JOB = ({ commit }, ID) => http.post(Api.admin.jobs.fecha.replace("?", ID))
    .then((e) => (notify(commit, e), e)).catch((e) => (notify(commit, e), e))

export const ANALISE_RECEITA = ({ commit }, data) => http.post(Api.admin.report.analiseReceita, data).catch(e => notify(commit, e))

export const JOB_VALOR_ADICIONAL = ({ commit }, data) => {
    let url = 'lancamento'
    if (data.tipo_lancamento == 'cobranca_cliente' && data.valor_doutor == null) data.valor_doutor = 0.00
    if (data.tipo_lancamento == 'desconto_pagamento') { data.duracao_desconto += ':00'; url = 'desconto_tempo' }
    if (data.tipo_lancamento == 'hora_extra') { data.duracao_hora_extra += ':00'; url = 'hora_extra' }
    http.post(Api.admin.jobs[url].replace("?", data.job), data).then((res) => {
        notify(commit, res);
        return res
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export const LANCAMENTOS = ({ commit }, ID) => http.get(Api.admin.jobs.lancamento.replace("?", ID)).catch((e) => {
    notify(commit, e)
    return e
})
export const ESTORNAR = ({ commit }, { job, id }) => http.delete(Api.admin.jobs.estornar.replace("?", job) + id).then((res) => {
    notify(commit, res);
    return res
}).catch((e) => {
    notify(commit, e)
    return e
})

export const EQUIPE_ADMIN_NOVO = ({ commit }, p) => DEFAULT(() => http.post(Api.admin.supporter_aggregate + `/doutor/${p.supporter}`, p), commit)
export const EQUIPE_ADMIN_LISTA = ({ commit }, ID) => DEFAULT(() => http.post(Api.admin.supporter_aggregate + `/lista/doutor/${ID}`), commit)

export const FUNCIONARIO_NOVO = ({ commit }, data) => api(Api.admin.funcionario.novo, data, commit)
export const FUNCIONARIO_GET = ({ commit }, data) => api(Api.admin.funcionario.get, data, commit)
export const FUNCIONARIO_LIST = ({ commit }, data) => api(Api.admin.funcionario.list, data, commit)
export const FUNCIONARIO_UPDATE = ({ commit }, data) => api(Api.admin.funcionario.update, data, commit)
export const FUNCIONARIO_DEL = ({ commit }, data) => api(Api.admin.funcionario.del, data, commit)
export const FUNCIONARIO_ACTIVE = ({ commit }, ID) => DEFAULT(() => http.put(Api.admin.funcionario.status.url.replace('?', ID)), commit)

export const JOBS_LIST = ({ commit }, filter) => api(Api.admin.jobs.list, filter, commit)
export const JOB_GET = ({ commit }, data) => api(Api.admin.jobs.get, data, commit)
export const JOB_CREATE = ({ commit }, data) => api(Api.admin.jobs.create, data, commit)

export const SUPPORTERS_LIST = ({ commit }, data) => api(Api.admin.supporter.list, data, commit)
export const SUPPORTERS_GET = ({ commit }, data) => api(Api.admin.supporter.get, data, commit)
export const SUPPORTERS_NEW = ({ commit }, data) => api(Api.admin.supporter.create, data, commit)
export const SUPPORTERS_UPDATE = ({ commit }, data) => api(Api.admin.supporter.update, data, commit)
export const SUPPORTERS_FILES = ({ commit }, data) => api(Api.admin.supporter.files, data, commit)
export const SUPPORTERS_DEL = ({ commit }, data) => api(Api.admin.supporter.del, data, commit)
export const SUPPORTERS_UPDATE_STATUS = ({ commit }, data) => http.put(Api.admin.supporter.update.url + data + '/status')
    .then((res) => {
        notify(commit, res); return res
    }).catch((e) => { notify(commit, e); return e })

export const LIMIT_KM = ({ commit }, ID) => DEFAULT(() => http.get(Api.admin.km.limit.replace("?", ID)), commit)

export const ADD_KM = ({ commit }, data) => {
    let JOBID = data.job
    delete data.job
    return http.post(Api.admin.km.add.replace("?", JOBID), data)
        .then((res) => notify(commit, res))
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export const REAGENDAR = ({ commit }, data) => {
    let ID = data.id
    delete data.id
    http.put(Api.admin.jobs.reagendar.replace('?', ID), data)
        .then((res) => notify(commit, res))
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export const JOB_VALIDATE = ({ commit }, data) => {
    let ID = data.id
    delete data.id
    http.put(Api.admin.jobs.validate.replace('?', ID), data).then((res) => notify(commit, res)).catch((e) => {
        notify(commit, e)
        return e
    })
}
export const JOB_INVALIDATE = ({ commit }, data) => {
    let ID = data.id
    delete data.id
    http.put(Api.admin.jobs.invalidate.replace('?', ID), data).then((res) => notify(commit, res)).catch((e) => {
        notify(commit, e)
        return e
    })
}
export const TOA = ({ commit }, data) => http.post(Api.admin.imports.toa, data)
    .then((res) => (notify(commit, res), res)).catch((e) => (notify(commit, e), e))

export const JOB_ASSOC = ({ commit }) => http.post(Api.admin.jobs.assoc).catch((e) => {
    notify(commit, e)
    return e
})

export const ADMIN_HISTORIC = ({ commit }, ID) => http.get(Api.admin.jobs.historic.replace('?', ID))
    .catch((e) => {
        notify(commit, e)
        return e
    })


export const SUPPORTERS_HISTORIC = ({ commit }, ID) => {
    return http.get(Api.admin.supporter.historic.url.replace('?', ID))
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export async function CATEGORIZE({ commit }, data) {
    let ID = data.id
    delete data.id
    return http.put(Api.admin.jobs.categorize.replace('?', ID), data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}
export async function JOB_CANCEL({ commit }, data) {
    let ID = data.id
    delete data.id
    return http.put(Api.admin.jobs.cancel.replace('?', ID), data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}
export async function ASSOCIATE({ commit }, data) {
    return http.put(Api.admin.supporter.associate.replace('?', data.id), data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export const BASECOST_LIST = ({ commit }, data) => api(Api.admin.basecost.list, data, commit)
export const BASECOST_CREATE = ({ commit }, data) => api(Api.admin.basecost.create, data, commit)
export const BASECOST_UPDATE = ({ commit }, data) => api(Api.admin.basecost.update, data, commit)
export const BASECOST_DEL = ({ commit }, data) => api(Api.admin.basecost.del, data, commit)
export const BASECOST_GET = ({ commit }, data) => api(Api.admin.basecost.get, data, commit)
export const FLAGS_LIST = ({ commit }, data) => api(Api.admin.flags.list, data, commit)
export const FLAGS_CREATE = ({ commit }, data) => api(Api.admin.flags.create, data, commit)
export const FLAGS_UPDATE = ({ commit }, data) => api(Api.admin.flags.update, data, commit)
export const FLAGS_DEL = ({ commit }, data) => api(Api.admin.flags.del, data, commit)
export const CASHFLOW_GENERATE = ({ commit }, data) => api(Api.admin.report.cashflow.chart, data, commit)
export const ENTRY_LIST = ({ commit }, data) => api(Api.admin.report.cashflow.entry.list, data, commit)
export const ENTRY_NEW = ({ commit }, data) => api(Api.admin.report.cashflow.entry.new, data, commit)
export const ENTRY_UPDATE = ({ commit }, data) => api(Api.admin.report.cashflow.entry.update, data, commit)
export const ENTRY_DEL = ({ commit }, data) => api(Api.admin.report.cashflow.entry.del, data, commit)
export const ENTRY_GET = ({ commit }, data) => api(Api.admin.report.cashflow.entry.get, data, commit)
export const REPORT_CONTAAZUL = ({ commit }, data) => api(Api.admin.report.contaazul, data, commit)
export const EXTRACT_SUPPORTER = ({ commit }, data) => api(Api.admin.report.extractSupporter, data, commit)
export const ORIENTATION_SUPPORTER_GET = ({ commit }) => api(Api.admin.orientation.supporter.get, '', commit)
export const ORIENTATION_SUPPORTER_UPDATE = ({ commit }, data) => api(Api.admin.orientation.supporter.update, data, commit)
export const PAYMENT_CICLE = ({ commit }, data) => api(Api.admin.payment.cicle, data, commit)
export const PAYMENT_CNAB = ({ commit }, data) => api(Api.admin.payment.cnab, data, commit)

export const GUIDELINES_NEW = ({ commit }, data) => api(Api.admin.guidelines.new, data, commit)
export const GUIDELINES_LIST = ({ commit }, data) => api(Api.admin.guidelines.list, data || {}, commit)
export function GUIDELINES_UPDATE({ commit }, data) {
    return http.put(Api.admin.guidelines.base + data.id, data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}
export function GUIDELINES_DEL({ commit }, data) {
    return http.delete(Api.admin.guidelines.base + data.id)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export const BANK_NEW = ({ commit }, data) => api(Api.admin.bank.new, data, commit)
export const BANK_LIST = ({ commit }, data) => api(Api.admin.bank.list, data, commit)
export function BANK_UPDATE({ commit }, data) {
    return http.put(Api.admin.bank.base + data.id, data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export function BANK_DEL({ commit }, data) {
    return http.delete(Api.admin.bank.base + data.id)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}


export const BASISCOST_LIST = ({ commit }, data) => api(Api.admin.basisCost, data || {}, commit)

export const SERVICESTYPE_GET = (_, ID) => http.get(Api.admin.servicestype.base + ID)
export const SERVICESTYPE_LIST = ({ commit }, data) => api(Api.admin.servicestype.list, data, commit)

export function SERVICESTYPE_NEW({ commit }, data) {
    return http.post(Api.admin.servicestype.new, data).then((res) => {
        notify(commit, res)
        return res
    }).catch((e) => {
        notify(commit, e)
    })
}

export function SERVICESTYPE_UPDATE({ commit }, data) {
    return http.put(Api.admin.servicestype.base + data.id, data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export function SERVICESTYPE_DEL({ commit }, data) {
    return http.delete(Api.admin.servicestype.base + data.id)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export function LISTAR_RETORNO({ commit }, data) {
    return http.get(Api.admin.payment[data]).catch(e => notify(commit, e))
}
export function UPLOAD_RETORNO({ commit }, { t, file }) {
    return http.post(Api.admin.payment[t], file).then(e => notify(commit, e)).catch(e => notify(commit, e))
}
export function GET_RETORNO({ commit }, ID) {
    return http.get(Api.admin.payment.pagamento.replace("pagamento", ID)).catch(e => notify(commit, e))
}
export function COST_PROPORTION({ commit }) {
    return http.get(Api.admin.servicestype.costProportion).catch((e) => {
        notify(commit, e)
    })
}

export function PENDENCIES_LIST({ commit }) {
    return http.post(Api.admin.pendencies.list).catch((e) => {
        notify(commit, e)
    })
}

export function PENDENCIES_NEW({ commit }, data) {
    return http.post(Api.admin.pendencies.new, data).catch((e) => {
        notify(commit, e)
    })
}

export function NEGOCIOS({ commit }) {
    return http.post(Api.admin.negocios).catch((e) => notify(commit, e))
}

export function PENDENCIES_UPDATE({ commit }, data) {
    return http.put(Api.admin.pendencies.update + data.id, data)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export function PENDENCIES_DEL({ commit }, data) {
    return http.delete(Api.admin.pendencies.del + data.id)
        .then((res) => {
            notify(commit, res)
            return res
        }).catch((e) => {
            notify(commit, e)
            return e
        })
}

export function LOAD_CLIENTS({ commit }, filter) {
    filter = clear(filter)
    return http.post(Api.admin.clients.list, { ...filter })
        .then((res) => {
            if (res) {
                commit('SET_CLIENTS', res.data)
                return res
            }
        }).catch((e) => {
            notify(commit, e)
        })
}
export function CLIENT_POST({ commit }, data) {
    return http.post(Api.admin.clients.put, data).then((e) => (notify(commit, e), e)).catch((e) => (notify(commit, e), e))
}
export function CLIENT_PUT({ commit }, data) {
    return http.put(Api.admin.clients.put + data.id, data).then((e) => (notify(commit, e), e)).catch((e) => (notify(commit, e), e))
}
export function CLIENT_ACTIVATE({ commit }, ID) {
    return http.put(Api.admin.clients.put + ID + "/status").then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function CLIENT_DEL({ commit }, ID) {
    return http.delete(Api.admin.clients.put + ID).then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function CLIENT_GET({ commit }, ID) {
    return http.get(Api.client.get + ID)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function CLIENT_CITIES({ commit }, DATA) {
    return http.post(Api.admin.clients.cities + '/lista', DATA)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function CLIENT_CITIES_ADD({ commit }, DATA) {
    return http.post(Api.admin.clients.cities, DATA)
        .then(r => (notify(commit, r), r)).catch(r => (notify(commit, r), r))
}
export function CLIENT_CITIES_DEL({ commit }, ID) {
    return http.delete(`${Api.admin.clients.cities}/${ID}`)
        .then(r => (notify(commit, r), r)).catch(r => (notify(commit, r), r))
}
export function CLIENT_OPERACAO({ commit }, data) {
    let pay = { ...data }
    delete pay.t
    delete pay.ID
    return http[data.t](Api.admin.clients.operacao.replace('?', data.ID) + (['put', 'delete'].includes(data.t) ? `/${data.id}` : ''), data.t != "delete" ? pay : '').then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function CLIENT_OPERACAO_ACTIVE({ commit }, data) {
    return http.put(Api.admin.clients.operacao.replace('?', data.ID) + '/' + data.id + '/status').then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function CLIENT_USUARIO({ commit }, data) {
    let pay = { ...data }
    delete pay.t
    delete pay.ID
    return http[data.t](Api.admin.clients.usuario.replace('?', data.ID) + (['put', 'delete'].includes(data.t) ? `/${data.id}` : ''), data.t != "delete" ? pay : '').then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function CLIENT_USUARIO_ACTIVE({ commit }, data) {
    return http.put(Api.admin.clients.usuario.replace('?', data.ID) + '/' + data.id + '/status').then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}

export function CLIENT_USUARIO_LIST({ commit }, ID) {
    return http.post(Api.admin.clients.usuario.replace('?', ID) + '/lista').catch((e) => notify(commit, e))
}
export function CLIENT_OPERACAO_LIST({ commit }, ID) {
    return http.post(Api.admin.clients.operacao.replace('?', ID) + '/lista').catch((e) => notify(commit, e))
}

export function TAKE_JOB({ commit }, { idJob, idAdmin }) {
    return http.put(Api.admin.take.replace('?', idJob).concat(idAdmin)).catch((e) => {
        notify(commit, e)
    })
}

export function CREATE_COMM({ commit }, comm) {
    return http.post(Api.admin.communication.create, comm).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
    })
}

export function UPDATE_COMM({ commit }, comm) {
    return http.put(Api.admin.communication.create + '/' + comm.id, comm).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
    })
}

export function GET_COMMS({ commit }, filter) {
    filter = clear(filter)
    return http.post(Api.admin.communication.get, filter).catch((e) => {
        notify(commit, e)
    })
}

export function GET_COMM({ commit }, id) {
    return http.get(Api.admin.communication.create + '/' + id).catch((e) => {
        notify(commit, e)
    })
}

export function GET_TEMPLATE({ commit }, id) {
    return http.get(Api.admin.template.update.replace('?', id)).catch((e) => {
        notify(commit, e)
    })
}

export function UPDATE_TEMPLATE({ commit }, file) {
    if (file.get('arquivo') && file.get('id'))
        return http.put(Api.admin.template.update.replace('?', file.get('id')), file).catch((e) => {
            notify(commit, e)
        })
}

export function DEL_COMM({ commit }, id) {
    return http.delete(Api.admin.communication.create + '/' + id).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
    })
}

export function SLA({ commit }) {
    return http.get(Api.admin.sla).catch((e) => {
        notify(commit, e)
    })
}


export function CREATE_TEMPLATE({ commit }, file) {

    if (file.get('arquivo'))
        return http.post(Api.admin.template.create, file).catch((e) => {
            notify(commit, e)
        })
    else {
        commit('general/SET_STATUS', { text: 'Arquivo de template inválido', color: 'red' }, { root: true })
        return false
    }
}

export function PUBLISH_COMM({ commit }, id) {
    return http.post(Api.admin.communication.publish, { id_comunicado: id }).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
    })
}

export function NEW_AGGREGATE({ commit }, client) {
    return http.post(Api.admin.clients_aggregate, client).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function NEW_AGGREGATE_SUPPORTER({ commit }, supporter) {
    return http.post(Api.admin.supporter_aggregate, supporter).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function AGGREGATE_SUPPORTER_LIST({ commit }, filter) {
    filter = clear(filter)
    return http.post(Api.admin.supporter_aggregate + '/lista', filter).then(r => {
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function UPDATE_SUPPORTER({ commit }, supporter) {
    return http.put(Api.admin.supporter_aggregate + '/' + supporter.id, supporter).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function DEL_AGGREGATE({ commit }, id) {
    return http.delete(Api.admin.clients_aggregate_del.replace('?', id)).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function DEL_AGGREGATE_SUPPORTER({ commit }, data) {
    return http.delete(Api.admin.supporter_aggregate_activate.replace('?', data.id), { excluir_dados: data.del }).then(r => {
        r.data.msg = "Conta excluida com sucesso!";
        notify(commit, r)
        if (!data.notRedirect)
            window.location = Api.motivo;
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function ACTIVATE_AGGREGATE({ commit }, id) {
    return http.put(Api.admin.supporter_aggregate_activate.replace('?', id)).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function IMPORT_AGGREGATE({ commit }, { form, id }) {
    return http.post(Api.admin.clients_aggregate_import.replace('?', id), form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function AGGREGATE_LIST({ commit }, filters) {
    filters = clear(filters)
    return http.post(Api.admin.clients_aggregate_list, filters)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function LOAD_NFS({ commit }, filters) {
    filters = clear(filters)
    return http.post(Api.admin.nf, filters)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function NF_VALIDATE({ commit }, data) {
    let motivo = data.motivo ? { motivo: data.motivo } : ''
    return http.put(Api.admin.nf_validate.replace('?', data.id_nota_fiscal) + data.operacao, motivo)
        .then(r => {
            notify(commit, r)
            return r
        })
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function LIST_COMM_SUPPORTER({ commit }, filter) {
    filter = clear(filter)
    return http.post(Api.admin.communication.supporter.list, filter).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function CREATE_COMM_SUPPORTER({ commit }, data) {
    return http.post(Api.admin.communication.create_supporter, data).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function DEL_COMM_SUPPORTER({ commit }, id) {
    return http.delete(Api.admin.communication.create_supporter + '/' + id).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function GET_COMM_SUPPORTER({ commit }, id) {
    return http.get(Api.admin.communication.create_supporter + '/' + id).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function UPDATE_COMM_SUPPORTER({ commit }, comm) {
    return http.put(Api.admin.communication.create_supporter + '/' + comm.id, comm).then(r => {
        notify(commit, r)
        return r
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function LIST_CANAIS({ commit }) {
    return http.get(Api.admin.communication.canais).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function STATS_COMMUNICATION({ commit }, data) {
    return http.post(Api.admin.communication.stats, data).catch((e) => {
        notify(commit, e)
        return e
    })
}


const tc = (f, commit) => f().then(r => (notify(commit, r), r)).catch((e) => (notify(commit, e), e))

export const ESPECIALITY_LIST = ({ commit }, data) => api(Api.admin.speciality, data || {}, commit)
export const AREAS_LIST = (_, data) => http.post(Api.admin.area.list, data)
export const COMPETENCIAS_LIST = (_, data) => http.post(Api.admin.competencia.list, data)

export async function ESPECIALIDADES_LIST({ commit }) {
    const especialidades = {
        title: "especialidades",
        list: [],
        newItem: false,
        edit: (item) => item.show = true,
        create: (newItem) => {
            if (newItem.type == "especialidade")
                return tc(() => http.post(Api.admin.especialidade.post, { nome: newItem.nome }), commit)
            if (newItem.type == "area")
                return tc(() => http.post(Api.admin.area.post, { id_especialidade: newItem.id_especialidade, nome: newItem.nome }), commit)
            if (newItem.type == "competencia")
                return tc(() => http.post(Api.admin.competencia.post, { id_competencia: newItem.id_competencia, id_area: newItem.id_area, nome: newItem.nome, descricao: newItem.descricao }), commit)
        },
        update(item) {
            if (item.type == 'area')
                return tc(() => http.put(Api.admin.area.put + item.id, { id_especialidade: item.id_especialidade, nome: item.nome, etag: item.etag }), commit)
            if (item.type == 'competencia')
                return tc(() => http.put(Api.admin.competencia.put + item.id, { id_especialidade: item.id_especialidade, id_area: item.id_area, nome: item.nome, descricao: item.descricao, etag: item.etag }), commit)

            return tc(() => http.put(Api.admin.especialidade.put + item.id, { nome: item.nome, etag: item.etag }), commit)
        },
        del: (item) => {
            if (item.type == 'area')
                return tc(() => http.delete(Api.admin.area.del + item.id), commit)
            if (item.type == 'competencia')
                return tc(() => http.delete(Api.admin.competencia.del + item.id), commit)

            return tc(() => http.delete(Api.admin.especialidade.del + item.id), commit)
        },

    };

    return await http.post(Api.admin.speciality.url, {}).then(({ data }) => {
        if (data) {
            especialidades.list = data
            return especialidades
        }
    }).catch((e) => {
        notify(commit, e)
        return especialidades
    })
}

export function CERTIFICATERS_LIST({ commit }) {
    return http.post(Api.certificater.lists).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function CERTIFICATER_LIST({ commit }) {
    const certificatesTree = {
        title: "certificados",
        list: [],
        newItem: false,
        edit: (item) => item.show = true,
        create: (newItem) => {
            if (newItem.type == "certificadora")
                return tc(() => http.post(Api.certificater.post, { nome: newItem.nome }), commit);
            if (newItem.type == "certificado")
                return tc(() => http.post(Api.certificate.post, { id_certificadora: newItem.id_certificadora, nome: newItem.nome }), commit)
        },
        del: (item) => {
            if (item.id_certificadora == 0)
                return tc(() => http.delete(Api.certificater.delete.replace('?', item.id)), commit)
            if (item.id_certificadora > 0)
                return tc(() => http.delete(Api.certificate.delete.replace('?', item.id)), commit)
        },
        update(item) {
            if (item.id_certificadora == 0)
                return tc(() => http.put(Api.certificater.put.replace('?', item.id), { id: item.id, etag: item.etag, nome: item.nome }), commit)
            if (item.id_certificadora > 0)
                return tc(() => http.put(Api.certificate.put.replace('?', item.id), { etag: item.etag, nome: item.nome, descricao: item.descricao, id: item.id, id_certificadora: item.id_certificadora }), commit)
        }
    };

    return http.post(Api.certificater.list).then((r) => {
        if (r.status == 200) {
            certificatesTree.list = r.data
            return certificatesTree
        }
    }).catch((e) => {
        notify(commit, e)
        return certificatesTree
    })
}

export function TOOLTYPES_LIST({ commit }) {
    return http.post(Api.tooltype.lists).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function TOOLTYPE_LIST({ commit }) {
    const toolsTree = {
        title: "ferramentas",
        list: [],
        newItem: false,
        edit: (item) => item.show = true,
        create: (newItem) => {
            if (newItem.type == "tipo_ferramenta")
                return tc(() => http.post(Api.tooltype.post, { nome: newItem.nome }), commit)
            if (newItem.type == "ferramenta")
                return tc(() => http.post(Api.tool.post, {
                    id_tipo_ferramenta: newItem.id_tipo_ferramenta,
                    nome: newItem.nome,
                    descricao: newItem.descricao
                }), commit);
        },
        del: (item) => {
            if (item.id_tipo_ferramenta == 0)
                return tc(() => http.delete(Api.tooltype.delete.replace('?', item.id)), commit)
            if (item.id_tipo_ferramenta > 0)
                return tc(() => http.delete(Api.tool.delete.replace('?', item.id)), commit)
        },
        update(item) {
            if (item.id_tipo_ferramenta == 0)
                return tc(() => http.put(Api.tooltype.put.replace('?', item.id), { id: item.id, etag: item.etag, nome: item.nome }), commit)
            if (item.id_tipo_ferramenta > 0)
                return tc(() => http.put(Api.tool.put.replace('?', item.id), { etag: item.etag, nome: item.nome, descricao: item.descricao, id: item.id, id_tipo_ferramenta: item.id_tipo_ferramenta }), commit)
        }
    };
    return http.post(Api.tooltype.list).then((r) => {
        if (r.status == 200) {
            toolsTree.list = r.data
            return toolsTree
        }
    }).catch((e) => {
        notify(commit, e)
        return toolsTree
    })
}


export function MENU_GET({ commit }, data) {
    return http.post(Api.admin.menu.get, data).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function MENU_POST({ commit }, data) {
    return http.post(Api.admin.menu.post, data).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function MENU_PUT({ commit }, data) {
    return http.put(Api.admin.menu.put + data.id, data).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function MENU_DEL({ commit }, id) {
    return http.delete(Api.admin.menu.delete + id).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function GROUP_LIST({ commit }, data) {
    return http.post(Api.admin.group.list, data).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function GROUP_NEW({ commit }, data) {
    return http.post(Api.admin.group.new, data).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function GROUP_PUT({ commit }, data) {
    return http.put(Api.admin.group.put + data.id, data).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function GROUP_DEL({ commit }, id) {
    return http.delete(Api.admin.group.delete + id).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

// GROUP PERMISSIONS
export function GROUP_PERMISSIONS({ commit }, data) {
    return http.post(Api.admin.group.permissions.list, data).catch((e) => {
        notify(commit, e)
        return e
    })
}

export function GROUP_PERMISSIONS_ADD({ commit }, data) {
    return http.post(Api.admin.group.permissions.put, data).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}
export function GROUP_PERMISSIONS_DEL({ commit }, id) {
    return http.delete(Api.admin.group.permissions.del + id).then((r) => {
        notify(commit, r)
        return r;
    }).catch((e) => {
        notify(commit, e)
        return e
    })
}

// PARCEIROS
export function PARTNERS_ENABLE({ commit }, data) {
    return http.post(Api.admin.partners.enable, data)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function PARTNERS_POST({ commit }, data) {
    return http.post(Api.admin.partners.post, data)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function PARTNERS_ADD({ commit }, data) {
    return http.put(Api.admin.partners.city.associate.replace('?', data.id_doutor).replace('?', data.id_cidade), data)
        .then((r) => {
            notify(commit, r)
            return r;
        })
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function PARTNERS_REMOVE({ commit }, data) {
    return http.put(Api.admin.partners.city.disassociate.replace('?', data.id_doutor).replace('?', data.id_cidade), data)
        .then((r) => {
            notify(commit, r)
            return r;
        })
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function PARTNERS_INFO({ commit }, data) {
    return http.get(Api.admin.partners.get.replace('?', data.id_doutor).replace('?', data.id_cidade), data)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}
export function SUPPORTER_INFO({ commit }, data) {
    return http.get(Api.admin.partners.supporter.replace('?', data.id_doutor).replace('?', data.id_cidade), data)
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function PARTNERS_ADD_CLIENT({ commit }, data) {
    return http.put(Api.admin.partners.client.associate.replace('?', data.id_doutor).replace('?', data.id_cidade).replace('?', data.id_cliente), data)
        .then((r) => {
            notify(commit, r)
            return r;
        })
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

export function PARTNERS_REMOVE_CLIENT({ commit }, data) {
    return http.put(Api.admin.partners.client.disassociate.replace('?', data.id_doutor).replace('?', data.id_cidade).replace('?', data.id_cliente), data)
        .then((r) => {
            notify(commit, r)
            return r;
        })
        .catch((e) => {
            notify(commit, e)
            return e
        })
}

